import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom';

import { Modal, Button } from 'components'
import InnovationAnimate from 'resources/innovation-animate.svg'

import * as actionCreators from 'store/actions';
import { pageContext } from 'context';

const Container = styled.div`
    background-color: var(--focus-color);
    padding: 2rem;
    box-shadow: var(--box-shadow);
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    justify-content: center;
    align-items: center;
    max-width: 20rem;
    width: 80vw;
    color: #fff;
`

const Title = styled.div`
    font-weight: bold;
    text-align: center;
`

const Text = styled.div`
    font-size: 0.9rem;
    text-align: center;
`

const ButtonContainer = styled.div`
    display: grid;
    grid-template-rows: auto auto;
    grid-row-gap: 0.3rem;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: 0.5rem 0 0 0;
`

const Image = styled.img`
    width: 100%;
    max-width: 25rem;
`

const ref = {
    item: {
        title: "You've just hit the 1k task limit!",
        message: 'Upgrading to Atomicly Premium will give you unlimited tasks and much more'
    },
    page: {
        title: "You've just hit the 5 pages limit!",
        message: 'Upgrading to Atomicly Premium will give you unlimited pages'
    },
    integrations: {
        title: "You've discovered a premium feature!",
        message: 'Upgrading to Atomicly Premium will give you unlimited pages'
    },
    calendar: {
        title: "You've discovered a premium feature!",
        message: 'Upgrading to Atomicly Premium will give you unlimited pages'
    },
}

const upgradeStyle = {
    backgroundColor: '#474747',
    color: '#fff',
    fontWeight: 'bold',
    margin: 0,
    boxShadowColor: '#141414',
    hoverColor: '#fff',
    width: '15rem'
    // margin: '0 0.5rem'
}

const closeStyle = {
    backgroundColor: 'transparent',
    color: '#fff',
    margin: 0,
    // margin: '0 0.5rem',
    boxShadowColor: 'transparent',
    hoverColor: '#000'
}

const UpgradeModal = props => {
    const {
        trigger
    } = props;
    const dispatch = useDispatch();
    let history = useHistory();
    const user = useSelector(state => state.auth.user)

    const onUpgrade = () => {
        const oldUser = {...user}
        let updatedUser = user
        updatedUser['activePageID'] = `${pageContext.MODULES.SETTINGS}-subscription`
        updatedUser['activePageType'] = pageContext.TYPES.MODULES
        dispatch(actionCreators.updateUser(updatedUser, oldUser))
        dispatch(actionCreators.setModal(null,null))
        history.push(pageContext.MODULES.SETTINGS.toLowerCase())
    }

    const onClose = () => {
        dispatch(actionCreators.setModal(null,null))
    }

    return(
        <Modal>
            <Container>
                <Title>{ref[trigger] ? ref[trigger]['title'] : "You've discovered a premium feature"}</Title>
                <Image src={InnovationAnimate}/> 
                <Text>{ref[trigger] ? ref[trigger]['message'] : 'Upgrade to Atomicly Premium to enjoy this feature'}</Text>
                <ButtonContainer>
                    <Button text='Upgrade' styles={upgradeStyle} onSelect={onUpgrade}/>
                    <Button text='Maybe later' styles={closeStyle} onSelect={onClose}/>
                </ButtonContainer>
            </Container>
        </Modal>
        
    )
}

export default UpgradeModal;